// src/Components/ParameterCard/ParameterCard.js
import React, { useEffect, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import './ParameterCard.css';

const ParameterCard = ({ parameter, selectedValues, setSelectedValues, values }) => {
    const [filter, setFilter] = useState('');

    // Extract the selected array for this parameter
    const selectedEntry = selectedValues[parameter.id] || { values: [] };
    const selected = selectedEntry.values || [];

    useEffect(() => {
        // If "All" is pre-selected, ensure the checkbox state
        if (selected.includes('-1')) {
            // no-op, but could trigger UI side-effects if needed
        }
    }, [selected]);

    const handleValueChange = (value) => {
        // Delegate back to parent
        setSelectedValues(parameter, value);
    };

    const handleSelectAllChange = () => {
        // Toggling "All"
        setSelectedValues(parameter, '-1');
    };

    const filteredValues = values.filter(option =>
        option.value.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <Card className="mb-3 parameter-card">
            <Card.Body>
                <Card.Title className='text-info'>{parameter.displayName.toUpperCase()}</Card.Title>
                <Form.Control
                    type="text"
                    placeholder="Filter values..."
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                    size='sm'
                    className='mt-2'
                />
                <div className="values-list p-2 mt-3">
                    {/* "All" Checkbox */}
                    {filteredValues.length > 0 && (
                        <Form.Check
                            key="all"
                            type="checkbox"
                            label="All"
                            checked={selected.includes('-1')}
                            onChange={handleSelectAllChange}
                        />
                    )}
                    {/* Individual Options */}
                    {filteredValues.map(option => (
                        <Form.Check
                            key={option.id}
                            type="checkbox"
                            label={option.value}
                            checked={
                                selected.includes('-1') ||
                                selected.includes(option.id.toString())
                            }
                            onChange={() => handleValueChange(option.id.toString())}
                        />
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ParameterCard;
